export default __webpack_public_path__ + "static/media/left.icon.b745c194.svg";